import React, { ReactNode, useState, useEffect } from 'react';
import { useAppSelector } from '../store/hooks/reduxHooks';
import { UserRole } from '../types/auth';

type DateRange = {
  startDate: Date | null;
  endDate: Date | null;
};

interface ReportDateRangeEnforcerProps {
  children: ReactNode;
  dateRange: DateRange;
  isFilterApplied: boolean;
}

/**
 * Component that enforces date range selection for CleverPe users
 * If the user is a CleverPe user and no date range is selected, it shows a message
 * Otherwise, it renders its children
 */
const ReportDateRangeEnforcer: React.FC<ReportDateRangeEnforcerProps> = ({
  children,
  dateRange,
  isFilterApplied
}) => {
  const { user } = useAppSelector(state => state.auth);
  const [showWarning, setShowWarning] = useState(false);
  
  useEffect(() => {
    // Only enforce for CleverPe users
    if (user?.role === UserRole.CLEVERPE_USER) {
      // setShowWarning(!isFilterApplied || !dateRange.startDate || !dateRange.endDate);
      setShowWarning(false);
    } else {
      setShowWarning(false);
    }
  }, [user, dateRange, isFilterApplied]);
  
  if (showWarning) {
    return (
      <div className="flex flex-col items-center justify-center h-[30vh] w-full text-center p-4">
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4 w-full max-w-lg">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-yellow-700">
                <span className="font-medium">Please select a date range</span>. 
                A date range filter is required to view this report.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  return <>{children}</>;
};

export default ReportDateRangeEnforcer; 